var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light-Outline_Play",
    "data-name": "Iconly/Light-Outline/Play",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Play",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M15,0A15,15,0,1,1,0,15,15.017,15.017,0,0,1,15,0Zm0,2.2A12.8,12.8,0,1,0,27.8,15,12.819,12.819,0,0,0,15,2.2Zm-.613,7.7c.761.318,6.1,3.053,6.1,5.1,0,1.917-4.806,4.6-6.034,5.11a4.2,4.2,0,0,1-1.535.386,1.462,1.462,0,0,1-1.076-.417c-.236-.233-.865-.855-.868-4.951,0-4.349.653-5,.868-5.211C12.608,9.153,13.855,9.672,14.387,9.895Z",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/playIcon.2741ee1a5a1f50f7f73dfed8bddf3d8a.svg";
export { ForwardRef as ReactComponent };